import { BASE_URL } from '../../general/variables';
import { checkEmptyString, dateFormatter, dtProcessing, ellipseText, encryptNIP, initDefaultSelect2, loadJSSVG, makeKTBlock, nl2br, removeTags } from '../../general/functions';
import { generateEventColour, formatPrograms } from './_functions';
import { addDoc, collection } from 'firebase/firestore';
import { dbFirestore } from '../../general/firebase';

const eventFormatResult = function (event) {
  if (!event.id) {
    return event.text;
  }

  let curObj = {
    type: null,
    text: null,
  };

  switch (event.type) {
    case 'b8018ae69c':
      curObj.type = 'badge-primary';
      curObj.text = 'Expo';
      break;

    case '1f64078aab':
      curObj.type = 'badge-warning';
      curObj.text = 'Info Session';
      break;

    case '5de109bf':
      curObj.type = 'badge-info';
      curObj.text = 'Online Consultation';
      break;

    case '9712c02c831':
      curObj.type = 'badge-danger';
      curObj.text = 'School Fair';
      break;

    default:
      curObj.type = 'badge-danger';
      curObj.text = 'General';
      break;
  }

  let $event = $(`<span class="font-weight-bolder">${event.name} <span class="badge ${curObj.type} ml-4">${curObj.text} ${event.date}</span></span>`);

  return $event;
};

const initEventSelect2 = function () {
  $('#filterCard [name="eventNameFilter"]').select2({
    ajax: {
      url: BASE_URL + 'DatabaseController/getFilteredEvents',
      data: function (params) {
        let query = {
          q: params.term,
          search: params.term,
          page: params.page || 1,
        };

        return query;
      },
    },
    allowClear: true,
    cache: true,
    width: '100%',
    placeholder: 'Select event',
    templateResult: eventFormatResult,
    // templateSelection: eventFormatSelection
  });

  $('#editDatabaseModal [name="editMajorInterest"]').select2({
    language: {
      inputTooShort: function (args) {
        // args.minimum is the minimum required length
        // args.input is the user-typed text
        return 'Please enter ' + args.minimum + ' characters to start searching';
      },
      errorLoading: function () {
        return 'Error loading results';
      },
      loadingMore: function () {
        return 'Loading more results';
      },
      noResults: function () {
        return 'No results found';
      },
      searching: function () {
        return 'Searching major...';
      },
      maximumSelected: function (args) {
        // args.maximum is the maximum number of items the user may select
        return 'Error loading results';
      },
    },
    ajax: {
      url: BASE_URL + 'Students/getMajorList',
      delay: 120,
      data: function (params) {
        return {
          q: params.term,
        };
      },
    },
    width: '100%',
    placeholder: 'Select major',
    minimumInputLength: 3,
    allowClear: true,
    escapeMarkup: function (markup) {
      return markup;
    },
  });

  initDefaultSelect2(
    true,
    {
      endpoint: `${BASE_URL}/Select2Controller/getSchool`,
      data: { optional: 'id-text-same' },
    },
    '#filterCard [name="searchSchool"]',
    undefined,
    $(this).data('placeholder'),
    false,
    true
  );

  initDefaultSelect2(false, null, '#filterCard [name="searchAdsCategory"]', undefined, $(this).data('placeholder'));
  initDefaultSelect2(
    true,
    {
      endpoint: `${BASE_URL}/Select2Controller/getCities`,
      data: { optional: 'id-text-same' },
    },
    '#filterCard [name="searchCity"]',
    undefined,
    $(this).data('placeholder'),
    false,
    true
  );

  initDefaultSelect2(
    true,
    {
      endpoint: `${BASE_URL}/Select2Controller/getLeadsType`,
      // data: { optional: 'id-text-same' },
    },
    '#filterCard [name="dataAdsLeads"]',
    undefined,
    $(this).data('placeholder'),
    false,
    true
  );

  initDefaultSelect2(
    true,
    {
      endpoint: `${BASE_URL}/Select2Controller/getSourceType`,
      // data: { optional: 'id-text-same' },
    },
    '#filterCard [name="dataAdsSource"]',
    undefined,
    $(this).data('placeholder'),
    false,
    true
  );

  initDefaultSelect2(
    false,
    null,
    '#filterCard [name="dataAdsLeadsScore"]',
    undefined,
    $(this).data('placeholder'),
    false,
    false,
    true,
    Infinity,
    false,
    null,
    function (markup) {
      return markup;
    },
    function (data) {
      if (!data.id) return data.text;
      return $(data.element).data('html');
    },
    function (data) {
      if (!data.id) return data.text;
      return $(data.element).data('html');
    }
  );
};

function formatToWhatsapp(number) {
  if (!number) return "";

  // 1. Hilangkan semua karakter non-digit
  let fMobile = number.replace(/\D/g, "");

  // 2. Jika nomor diawali dengan 0 → ganti jadi 62
  if (fMobile.startsWith("0")) {
    fMobile = "62" + fMobile.substring(1);
  }
  // 3. Jika diawali dengan 62 → biarkan
  else if (fMobile.startsWith("62")) {
    fMobile = fMobile;
  }
  // 4. Jika diawali dengan 8 → tambahkan 62
  else if (fMobile.startsWith("8")) {
    fMobile = "62" + fMobile;
  }
  // 5. Jika ada prefix internasional lain (misal +62 yang sudah dihapus tanda +)
  else if (fMobile.startsWith("62")) {
    fMobile = fMobile;
  }

  return fMobile;
}

const databaseTable = $('#databaseTable').KTDatatable({
  data: {
    type: 'remote',
    source: {
      read: {
        url: BASE_URL + 'DatabaseController/studentDatatable',
        map: function (raw) {
          $('#counterStudent').html(raw.meta.total.toLocaleString('id-ID'));
          var dataSet = raw;

          if (typeof raw.data !== 'undefined') {
            dataSet = raw.data;
          }

          return dataSet;
        },
      },
    },
    pageSize: 10,
    serverPaging: true,
    serverFiltering: true,
    serverSorting: false,
    saveState: false,
  },
  layout: { scroll: false, footer: false },
  sortable: false,
  pagination: true,
  columns: [
    {
      field: 'REC_ID',
      title: '#',
      sortable: false,
      width: 20,
      selector: { class: 'student-checkbox' },
      template: function (row) {
        return row.REC_ID;
      },
    },
    {
      field: 'NAME',
      title: 'Student Information',
      sortable: false,
      type: 'text',
      width: 230,
      template: function (row) {
        let sName = '',
          sEmail = '',
          sMobile = '',
          sSchool = '',
          sGrade = '',
          sMajor = '',
          sCities = '';

        sName = checkEmptyString(row.NAME);
        sEmail = checkEmptyString(row.EMAIL);
        sSchool = checkEmptyString(row.SCHOOL);
        sGrade = checkEmptyString(row.GRADE);
        sMajor = checkEmptyString(row.MAJOR_INTEREST);
        sCities = checkEmptyString(row.CITY);
        sMobile = checkEmptyString(row.PHONE);

        const fMobile = formatToWhatsapp(sMobile.trim());
        let fSchool = sSchool;

        // Check if string splitable

        if (sSchool != '-') {
          if (sSchool.split('-').length == 1) {
            fSchool = sSchool;
          } else {
            let splitSchool = sSchool.split('-');

            fSchool = splitSchool[0];
          }
        }

        return `
          <ul class="list-unstyled font-size-sm student-details-list">
            <li class="font-size-lg font-weight-bolder">
              <span class="text-primary" data-type="NAME" data-value="${sName}">${sName}</span>
            </li>
            <li class="details-database">
              <i class="flaticon-multimedia-2 mr-2 text-dark" data-type="EMAIL" data-value="${sEmail}"></i>${sEmail}
            </li>

            <li class="d-none">
              <i data-type="BRANCH" data-value="${row.COMPANY_LOCATION}"></i>
              <i data-type="REC_ID" data-value="${row.REC_ID}"></i>
            </li>

            <li title="Mobile">
              <i class="fas fa-phone-alt mr-2 text-dark" data-type="PHONE" data-value="${sMobile}"></i>${sMobile}
              <a href="https://wa.me/${fMobile}" target="_blank">${loadJSSVG['whatsapp-sm']}</a>
            </li>
            <li title="Current/Last School/University">
              <i class="fas fa-university mr-2 text-dark"></i>${fSchool} 
            </li>
            <li title="Last Education" class="${sGrade == '-' ? 'd-none' : ''}">
              <i class="fas fa-user-graduate mr-2 text-dark"></i>${sGrade} 
            </li>
            <li title="Major Interest" class="${sMajor == '-' ? 'd-none' : ''}">
              <i class="fab fa-maxcdn mr-2 text-dark"></i>${formatPrograms(sMajor)}
            </li>
            <li title="City(Province)">
              <i class="flaticon-map-location mr-2 text-dark"></i>${sCities} 
            </li>
          </ul>
        `;
      },
    },
    {
      field: 'LEADS_SCORE',
      title: 'Lead Score',
      sortable: false,
      type: 'number',
      textAlign: 'center',
      width: 80,
      template: function (row) {
        switch (row.LEADS_SCORE) {
          case '1':
            return '<span class="font-size-sm"><i class="fas fa-thumbs-down mr-2" style="color:red;"></i>Cold</span>';
          case '2':
            return '<span class="font-size-sm"><i class="fas fa-thumbs-up mr-2" style="color:blue;"></i>Warm</span>';
          case '3':
            return '<span class="font-size-sm"><i class="fas fa-thumbs-up mr-2" style="color:green;"></i>Hot</span>';
          default:
            return `-`;
        }
      },
    },
    {
      field: 'COMPANY_LOCATION',
      title: 'Assigned',
      autoHide: false,
      sortable: false,
      type: 'text',
      width: 160,
      template: function (row) {
        let locName = '',
          counName = '';

        if (row.COMPANY_LOCATION == null || row.COMPANY_LOCATION == '' || row.COMPANY_LOCATION == 'NONE') {
          locName = '-';
        } else {
          locName = row.BRANCH_LOCATION;
        }

        if (row.ASSIGNED_COUNSELLOR == null || row.ASSIGNED_COUNSELLOR == '' || row.ASSIGNED_COUNSELLOR == 'NONE') {
          counName = '-';
        } else {
          counName = row.COUNSELLOR_NAME;
        }

        return `
          <ul class="list-unstyled font-size-sm text-danger">
            <li title="Office Location">
              <i class="far fa-building mr-2 text-danger"></i><strong>${locName}</strong>
            </li>
            <li class="my-2" title="Assigned Counsellor">
              <i class="fab fa-cuttlefish mr-2 text-danger"></i><strong>${counName}</strong>
            </li>
            <li title="Source From" >
              <i class="fab fa-sourcetree mr-2 text-danger"></i><strong>${generateEventColour(checkEmptyString(row.LEADS_NAME).toUpperCase()).name}</strong>
            </li>
          </ul>
        `;
      },
    },
    {
      field: 'CREATED',
      title: 'Other Info',
      sortable: false,
      type: 'text',
      width: 200,
      template: function (row) {
        let curOutput = `<ul class="list-unstyled font-size-sm">`;

        if (checkEmptyString(row.EVENT_NAME) != '-') {
          curOutput += `
            <li title="Event Name">
              <i class="far fa-calendar-alt mr-2 text-dark details-database"></i>
              ${checkEmptyString(row.EVENT_NAME).length < 15 ? checkEmptyString(row.EVENT_NAME).substring(0, 13) + '...' : checkEmptyString(row.EVENT_NAME)}
            </li>
          `;
        }

        if (checkEmptyString(row.COUNTRY_DESTINATION) != '-') {
          curOutput += `
            <li class="mt-2">
              <span class="font-weight-bolder">Country Destination:</span> ${checkEmptyString(row.COUNTRY_DESTINATION)}
            </li>
          `;
        }

        if (checkEmptyString(row.EDUCATION_CLASS) != '-') {
          /** Parse output */
          // console.log(JSON.parse(row.EDUCATION_CLASS));

          const curObj = JSON.parse(row.EDUCATION_CLASS);

          /** Berarti ada ini punya schoolfair */
          if (curObj.UNIV_ID != null && curObj.UNIV_NAME != null) {
            curOutput += `
              <li class="mt-2">
                <span class="font-weight-bolder">Visited Booth:</span> ${curObj.UNIV_NAME} <br/> <br/>
                <span class="font-weight-bolder">Notes:</span> ${curObj.NOTES} <br/>
              </li>
            `;
          }
        }

        if (checkEmptyString(row.INTAKE_YEAR) != '-') {
          curOutput += `
            <li class="mt-2">
              <span class="font-weight-bolder">University of Choice</span> ${checkEmptyString(row.INTAKE_YEAR)}
            </li>
          `;
        }

        if (checkEmptyString(row.INTAKE_YEAR) != '-') {
          curOutput += `
            <li class="mt-2">
              <span class="font-weight-bolder">Booth PIC</span> ${checkEmptyString(row.INTAKE_YEAR)}
            </li>
          `;
        }

        if (checkEmptyString(row.BOOKING_ID) != '-') {
          curOutput += `<li class="my-3">
                          <span class="font-weight-bolder">Booked for 
                            <span class="text-hover-primary togglePopover" data-html="true" data-trigger="hover" title="Consultation Details" data-content="${nl2br(row.BOOKING_DETAILS)} <br/><br/> Created by ${row.BOOKING_CREATOR} at ${dateFormatter(row.BOOKING_CREATED_DATE)}">
                              Consultation
                            </span> (${dateFormatter(row.BOOKING_DATE)}) by ${row.BOOKING_CREATOR}</span>
                        </li>`;

          curOutput += `<li class="my-3 d-flex flex-start">
                          <span class="fw-bolder pr-2">Consultation Status: </span>
                          ${row.BOOKING_STATUS == 'COMPLETED' ? '<i class="fs-4 fas fa-check-circle text-success"></i>' : '<i class="fs-7 fas fa-times-circle text-danger"></i>'}
                        </li>`;
        }

        curOutput += `
            <li class="mt-2">
              <span class="font-weight-bolder">Created Date :</span> ${dateFormatter(row.CREATED, 'SHORT')}
            </li>
          </ul>
        `;

        return curOutput;
      },
    },
    {
      field: 'QUESTION',
      title: 'Question',
      sortable: false,
      type: 'text',
      textAlign: 'text-justify',
      template: function (row) {
        return `<span class="font-size-sm ${checkEmptyString(row.QUESTION) != '-' ? 'font-weight-bolder' : ''}">${checkEmptyString(row.QUESTION)}</span>`;
      },
    },
  ],
});

const databaseTableAds = $('#databaseTableAds').DataTable({
  processing: true,
  serverSide: true,
  lengthMenu: [10, 25, 50, 100, 200],
  searchDelay: 1000,
  dom: '<t><"d-flex flex-stack"<l><i><p>>',
  language: dtProcessing,
  ajax: {
    url: `${BASE_URL}DatabaseController/studentDatatable`,
    type: 'POST',
    data: function (d) {
      param = { sorting: true, data_type: 'net-table' };
      $.extend(d, param);
      var param = $(`#databaseTableAds`).data('param');
      if (param) {
        $.extend(d, param);
      }
    },
    error: function (XMLHttpRequest, textStatus, errorThrown) {
      // callback when error throwed
      makeKTBlock('#databaseTableAds', 'hide');

      Swal.fire({
        html: 'Network trouble detected! Please try again later',
        icon: 'error',
        confirmButtonText: 'Close',
        showCancelButton: false,
      });
    },
    complete: function (data) {
      $('#counterStudent').html(data?.responseJSON?.recordsTotal?.toLocaleString('id-ID') ?? '-');
      makeKTBlock('#filterCard', 'hide');
      makeKTBlock('#databaseTableAds', 'hide');
    },
  },
  order: [[4, 'desc']],
  columns: [
    { data: 'NAME', className: 'fs-7', orderable: false },
    { data: null, className: 'fs-7', orderable: false },
    { data: null, className: 'fs-7', orderable: false },
    { data: 'LEADS_SCORE', className: 'fs-7 fw-bolder text-center' },
    { data: 'CREATED', className: 'fs-7 fw-bolder text-center' },
    { data: 'QUESTION', className: 'fs-7', orderable: false },
    { data: 'SOURCE_ID', className: 'fs-7 fw-bolder text-center' },
    { data: 'LEADS_ID', className: 'fs-7 fw-bolder text-center' },
    { data: 'UTM_SOURCE', className: 'fs-7', orderable: false },
    { data: 'EVENT_NAME', className: 'fs-7 fw-bolder' },
  ],
  columnDefs: [
    {
      targets: 0,
      render: function (data, type, row) {
        return `
            <ul class="list-unstyled m-0">
              <li><h3 class="fs-5 fw-bolder text-primary">${row.NAME}</h3></li>
              ${row.EMAIL ? `<li><span class="">${row.EMAIL}</span></li>` : ''}
              ${row.PHONE ? `<li><span class="">${row.PHONE}</span></li>` : ''}
            </ul>
          `;
      },
    },
    {
      targets: 1,
      render: function (data, type, row) {
        return `${row.CITY ?? '-'}${row.CITY != row.PROVINCE ? `<br><span class="fw-bolder">(${row.PROVINCE})</span>` : ''}`;
      },
    },
    {
      targets: 2,
      render: function (data, type, row) {
        return `
            <ul class="list-unstyled m-0">
              ${row.SCHOOL ? `<li><span class="fas fa-school mr-2"></span><span class="fw-bolder"> : ${row.SCHOOL}</span></li>` : ''}
              ${row.GRADE ? `<li><span class="fas fa-graduation-cap mr-2"></span><span class="fw-bold"> : ${row.GRADE}</span></li>` : ''}
            </ul>
          `;
      },
    },
    {
      targets: 3,
      render: function (data, type, row) {
        var curColor = 'light-dark',
          curTitle = 'No Score';
        switch (row.LEADS_SCORE) {
          case '1':
            curColor = 'primary';
            curTitle = 'Cold';
            break;
          case '2':
            curColor = 'warning';
            curTitle = 'Warm';
            break;
          case '3':
            curColor = 'danger';
            curTitle = 'Hot';
            break;
        }
        return `<span class="label label-inline label-${curColor}">${curTitle}</span>`;
      },
    },
    {
      targets: 4,
      render: function (data, type, row) {
        return dateFormatter(row.CREATED, 'SHORT');
      },
    },
    {
      targets: 5,
      render: function (data, type, row) {
        if (row.QUESTION) {
          let text = removeTags(row.QUESTION);
          if (row.QUESTION.length >= 100) {
            return `
                <p class="m-0 mb-3 fs-7">${ellipseText(text, 50, true)}</p>
                <a class="menu-link btn-readmore fs-8" data-type="questionDatabase" data-title="Student Question !" data-label="" data-encode="yes" data-content="${encodeURIComponent(row.QUESTION)}" href="javascript:;">Show more</a>`;
          }
          return text;
        }
        return '-';
      },
    },
    {
      targets: 6,
      render: function (data, type, row) {
        return row.SOURCE_ID ? row.SOURCE_NAME : '-';
      },
    },
    {
      targets: 7,
      render: function (data, type, row) {
        return row.LEADS_ID ? row.LEADS_NAME : '-';
      },
    },
    {
      targets: 8,
      render: function (data, type, row) {
        return row.UTM_SOURCE ? `<div class="togglePopover cursor-pointer" data-toggle="popover" data-content="${decodeURIComponent(row.UTM_SOURCE)}">${ellipseText(decodeURIComponent(row.UTM_SOURCE), 100, true)}</div>` : '-';
      },
    },
    {
      targets: 9,
      render: function (data, type, row) {
        return row.EVENT_NAME ? `<div class="togglePopover cursor-pointer" data-toggle="popover" data-content="${row.EVENT_NAME}">${ellipseText(row.EVENT_NAME, 100, true)}</div>` : '-';
      },
    },
  ],
});

const importValidation = $('#form_import').length
  ? FormValidation.formValidation(document.getElementById('form_import'), {
    fields: {
      importBranch: {
        validators: {
          notEmpty: {
            message: 'Branch cannot be empty',
          },
        },
      },
      importFiles: {
        validators: {
          notEmpty: {
            message: 'Files cannot be empty',
          },
        },
      },
      importType: {
        validators: {
          notEmpty: {
            message: 'Source cannot be empty',
          },
        },
      },
    },
    plugins: {
      trigger: new FormValidation.plugins.Trigger(),
      bootstrap: new FormValidation.plugins.Bootstrap(),
      excluded: new FormValidation.plugins.Excluded(),
    },
  })
  : null;

const editDatabase = document.getElementById('editDatabase');
const editValidation = $('#editDatabase').length
  ? FormValidation.formValidation(editDatabase, {
    fields: {
      editStudentName: {
        validators: {
          notEmpty: {
            message: 'Name cannot be empty',
          },
        },
      },
      editStudentEmail: {
        validators: {
          notEmpty: {
            message: 'Email cannot be empty',
          },
        },
      },
      editStudentPhone: {
        validators: {
          notEmpty: {
            message: 'Phone number cannot be empty',
          },
        },
      },
      editDatabaseLeads: {
        validators: {
          notEmpty: {
            message: 'Leads score cannot be empty',
          },
        },
      },
    },
    plugins: {
      trigger: new FormValidation.plugins.Trigger(),
      bootstrap: new FormValidation.plugins.Bootstrap(),
      excluded: new FormValidation.plugins.Excluded(),
    },
  })
  : null;

/**
 * Update 30 Juni 2025
 * Insert to Firebase
 */

const processFirebase = async function (mentions) {
  if (mentions.targetNIP === '' || mentions.targetNIP === null) {
    throw new Error('Empty staff');
  }

  const notifyPath = `User/${encryptNIP(mentions.targetNIP)}/Notification`;

  const docRef = await addDoc(collection(dbFirestore, notifyPath), {
    type: 'BOOK_CONSULTATION',
    targetNIP: mentions.targetNIP,
    targetName: mentions.targetName,
    creatorName: mentions.creatorName,
    creatorSN: mentions.creatorSN,
    others: JSON.stringify({
      actID: mentions.actID,
      studentID: mentions.studentID,
      details: mentions.actNotes,
    }),
    link: null,
    isRead: false,
    created: Date.now(),
  });

  return docRef.id;
};

export { databaseTable, databaseTableAds, editValidation, importValidation, initEventSelect2, processFirebase };
